import {EnumHelper} from '~/helpers/enumHelper'

export enum ProcessFlowStepType {
  RunIteration = 1,
  CallApi = 2,
  /**
   * @deprecated Use {GenerateDocumentV2} instead
   */
  GenerateDocument= 3,
  SendNotification = 4,
  RunProcess = 5,
  InitialStep = 6,
  SetData = 7,
  SaveData = 8,
  FindData = 9,
  DeleteData = 10,
  ExportCSV = 11,
  FindCount = 12,
  TakeAction = 13, // form submission action
  DisplayAForm = 14, // user interaction step for user to fill out data
  Redirect = 15, // user interaction step to redirect user to another url
  GenerateDocumentV2 = 16, // built in conjunction with Document Dynamic Inputs variables for certs/docs and the corresponding sub-object variable
}

/**
 * All steps are configurable since all steps can have conditional jump to logic
 */
export const ControllerConfigurableSteps = EnumHelper.toArray(ProcessFlowStepType)